import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { ConfigService } from '../services/config.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const config = inject(ConfigService);

  if (!config.isLoaded || !req.url.startsWith(config.apiEndPoint)) {
    return next(req);
  }

  // Homeowner routes use X-Session-Token; admin routes use Bearer JWT
  if (req.url.includes('/homeowners/') || req.url.includes('/homeowners')) {
    const sessionToken = auth.getSessionToken();
    if (sessionToken) {
      req = req.clone({ setHeaders: { 'X-Session-Token': sessionToken } });
    }
  } else {
    const adminToken = auth.getToken();
    if (adminToken) {
      req = req.clone({ setHeaders: { Authorization: `Bearer ${adminToken}` } });
    }
  }

  return next(req);
};
